<template lang="pug">
  TheFooter(
    v-if="$i18n.locale === locale.UK"
    :phone="page.customPhoneNumber"
    :isRebrand="isRebrand"
    email="")
  LocalisedTheFooterIE(
    v-else-if="$i18n.locale === 'ie'"
    :phone="page.customPhoneNumber"
    :isRebrand="isRebrand"
    email="info@anyvan.ie")
  LocalisedTheFooterUS(
    v-else-if="$i18n.locale === locale.US"
    :phone="page.customPhoneNumber"
    :uri="page.uri"
    :isRebrand="isRebrand"
    email="shipping@anyvan.com")
  LocalisedTheFooterDE(
    v-else-if="$i18n.locale === 'de'"
    :phone="page.customPhoneNumber"
    :isRebrand="isRebrand"
    email="kundenservice@anyvan.de")
  LocalisedTheFooterES(
    v-else-if="$i18n.locale === locale.SPAIN"
    :phone="'91 414 79 50'"
    :isRebrand="isRebrand"
    email="info@anyvan.es")
  LocalisedTheFooterFR(
    v-else-if="$i18n.locale === 'fr'"
    :phone="page.customPhoneNumber"
    :isRebrand="isRebrand"
    email="info@anyvan.fr")
  LocalisedTheFooterIT(
    v-else-if="$i18n.locale === 'it'"
    :phone="page.customPhoneNumber"
    :isRebrand="isRebrand"
    email="info@anyvan.it")
  TheFooter(
    v-else
    :phone="page.customPhoneNumber"
    :isRebrand="isRebrand"
    email="")
</template>

<script lang="ts">
import { defineComponent } from "vue"
import { LOCALE } from "~/constants/locale"

export default defineComponent({
  name: "TheFooterContainer",
  props: {
    page: {
      type: Object as () => Record<string, any>,
      required: true
    },
    isRebrand: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    return { locale: LOCALE }
  }
})
</script>
